export default __webpack_public_path__ + "media/titles/title_4_locale_da-4c23da78.png";